import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59b9ff5b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=59b9ff5b&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b9ff5b')) {
      api.createRecord('59b9ff5b', component.options)
    } else {
      api.reload('59b9ff5b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=59b9ff5b", function () {
      api.rerender('59b9ff5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SystemMessage/index.vue"
export default component.exports